export const viewNames = {
    selectMinicipality:'selectMinicipality',
}